import React from 'react'
import { Form, Select } from 'antd'
import { isMobile } from 'react-device-detect'
import { countries } from 'countries-list'
import * as PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

const CountryField = ({ handleChangeCountry = () => {}, name, label, rules, allowClear, formName }) => {
  const { t } = useTranslation()

  return (
    <Form.Item name={name} label={label} rules={rules}>
      <Select
        showSearch
        aria-autocomplete="none"
        optionFilterProp="children"
        className="fixArrowSelection"
        showAction={['click', isMobile ? '' : 'focus']}
        onSelect={handleChangeCountry}
        allowClear={allowClear}
        data-testid={`${formName || 'countryField'}-${name}`}
        filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
      >
        {Object.keys(countries).map(country => (
          <Select.Option value={country} key={country}>
            {`${t(countries[country].name)} ${
              countries[country].name !== countries[country].native ? ' - ' + countries[country].native : ''
            }`}
          </Select.Option>
        ))}
        <Select.Option value="OTHER">{t('OTHER')}</Select.Option>
      </Select>
    </Form.Item>
  )
}

CountryField.propTypes = {
  handleChangeCountry: PropTypes.func,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  rules: PropTypes.array.isRequired,
  allowClear: PropTypes.bool
}

export default CountryField
